export const GROUP_IDS = {
  BEST_WAY_TO_SHIP: 'best-way-to-ship',
  SERVICE_COLLECTIONS: 'service-collections',
};
